module.exports = __webpack_public_path__ + "static/img/statistics.ebf6380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/statistics.png
// module id = zkt8
// module chunks = 1